<template>
  <v-card fluid class="wrapper d-flex flex-column ma-0 pa-4 fill-height">
    <v-container class="pa-0 ma-0 mt-1 flex-grow-1 overflow-y-auto">
      <v-container class="pa-0 ma-0 pb-8 print-contract-page" style="height: 100%">
        <v-container
          class="pa-0 ma-0 d-flex justify-space-between align-center my-3 gap-3"
          style="direction: ltr"
        >
          <v-btn
            :loading="loading"
            @click="printContract"
            class="ma-0 pa-0"
            color="grey darken-2"
            height="32"
            outlined
          >
            <p class="font-weight-thin mb-0 me-2">{{ $t("print") }}</p>
            <v-icon>mdi-printer-outline</v-icon>
          </v-btn>
          <FlexibleAutocomplete
            v-model="contractName"
            title="contract_"
            type="contractName"
            :multiple="false"
            :currency="currencyId"
            :fetchData="fetchApi"
            class="mb-3"
          />
        </v-container>

        <v-container
          class="pa-3 ma-0 contract_template"
          style="line-height: 1.3; border: 1px solid #000"
        >
          <div v-if="loading" class="contract_template__loading">
            <v-progress-circular
              indeterminate
              color="grey darken-2"
              size="36
            "
              width="4"
            />
          </div>
          <template v-else>
            <v-card-text
              class="pa-0 ma-0 text-center text-body-1 d-flex align-center justify-center"
              style="border: 1px solid #000; border-bottom: none; min-height: 70px"
            >
              {{ contractTitel }}
            </v-card-text>
            <div
              class="contract-preview-text"
              v-html="contractText"
              style="
                border: 1px solid #9e9e9e;
                text-align: justify;
                direction: rtl;
                padding: 6px 8px;
                font-size: 12px;
              "
            ></div>
            <v-row class="mt-1" justify="space-between">
              <v-col cols="5" class="text-center">
                <div style="padding: 20px; border-radius: 0px; min-height: 60px">
                  {{ FirstSignature }}
                </div>
              </v-col>

              <v-col cols="5" class="text-center">
                <div style="padding: 20px; border-radius: 0px; min-height: 60px">
                  {{ SecondSignature }}
                </div>
              </v-col>
            </v-row>
          </template>
        </v-container>
      </v-container>
    </v-container>
  </v-card>
</template>

<script>
import General from "@/Mixins/general";
import FlexibleAutocomplete from "../../../components/general/patial/FlexibleAutocomplete.vue";

export default {
  name: "contract-print",
  components: {
    FlexibleAutocomplete,
  },
  mixins: [General],
  watch: {
    "contractName.id": {
      immediate: false,
      handler(newId) {
        this.contractId = newId || null;
        this.getContractById();
      },
    },
    "$route.query.id": {
      immediate: false,
      handler() {
        this.getContractById();
      },
    },
  },
  data() {
    const contractData = {
      contract_number: "",
      contract_date: "",
      contract_logo: "",
      header: "",
      contract_text: "",
      footer_left: "",
      footer_right: "",
    };
    return {
      loading: false,
      contractData,
      contractName: null,
      contractId: null,
      currencyId: "",
      FirstSignature: null,
      SecondSignature: null,
      contractTitel: null,
      contractText: null,
      contract_number: null,
      contract_date: null,
    };
  },
  mounted() {
    this.applyContractData(this.contractData);
    this.$nextTick(() => {
      this.getContractById();
    });
  },
  methods: {
    toPersianDigits(value) {
      if (value == null || value === "") return value;
      const map = "۰۱۲۳۴۵۶۷۸۹";
      return String(value).replace(/\d/g, (d) => map[Number(d)]);
    },
    htmlToPrintableText(htmlValue) {
      const html = (htmlValue || "").toString();
      return html
        .replace(/<br\s*\/?>/gi, "\n")
        .replace(/<\/p>/gi, "\n")
        .replace(/<[^>]+>/g, "")
        .replace(/\n{3,}/g, "\n\n")
        .trim();
    },
    normalizeContractData(raw) {
      const data = raw || {};
      const footer = data.footer || {};
      const firstSignature =
        footer.FirstSignature || data.footer_left || data.FirstSignature || "";
      const secondSignature =
        footer.SecondSignature || data.footer_right || data.SecondSignature || "";
      const body = data.body || data.contract_text || "";
      const printableBody = this.htmlToPrintableText(body);
      const rawHeader = data.contract_header || data.header || "";
      const header = rawHeader.includes("\n")
        ? rawHeader
        : rawHeader.replace(/\s+وزارت\s+تعاون/, "\nوزارت تعاون");
      const logo = data.contract_logo
        ? data.contract_logo
        : data.logo
        ? data.logo.startsWith("data:image")
          ? data.logo
          : `data:image/png;base64,${data.logo}`
        : "";

      return {
        ...data,
        body,
        contract_header: header,
        footer: {
          FirstSignature: firstSignature,
          SecondSignature: secondSignature,
        },
        contract_number: data.number ?? data.contract_number ?? null,
        contract_date: data.date ?? data.contract_date ?? null,
        contract_logo: logo,
        // keep compatibility with old bindings
        header,
        contract_text: printableBody,
        footer_left: firstSignature,
        footer_right: secondSignature,
      };
    },
    applyContractData(data) {
      const payload = this.normalizeContractData(data);
      this.contractData = payload;
      this.contract_date = payload?.contract_date;
      this.contract_number = payload?.contract_number;
      this.FirstSignature =
        payload.footer_left || payload?.footer?.FirstSignature || this.FirstSignature;
      this.SecondSignature =
        payload.footer_right || payload?.footer?.SecondSignature || this.SecondSignature;
      this.contractTitel = (payload.header || this.contractTitel).replace(/\n/g, " ");
      this.contractText = (
        payload.contract_text ||
        payload.body ||
        this.contractText
      ).replace(/\n/g, "<br><br>");
    },
    fetchApi(payload, template) {
      let params = {
        page: payload.page,
        key: payload.type,
        search: payload.search || "",
        options: JSON.stringify({
          itemsPerPage: 10,
        }),
        currency: this.currencyId,
      };
      return this.$axios.get(this.$endpoint + "contract", { params }).then((response) => {
        const list = response && response.data.data ? response.data.data : [];
        if (payload.page === 1 && !this.contractName && list.length > 0) {
          this.contractName = list[0];
        }
        this.contractId = this.contractName?.id || null;
        return {
          items: list,
          hasMore: list.length === 10,
        };
      });
    },
    getContractById() {
      let id = this.contractId;
      const queryId = this.$route?.query?.id || null;
      if (!id && !queryId) return;
      this.loading = true;
      this.$axios
        .get(this.$endpoint + "hrm/get-contract", {
          params: {
            commitment_id: queryId,
            contract_id: id,
          },
        })
        .then((response) => {
          const normalized = this.normalizeContractData(response.data || {});
          this.applyContractData(normalized);
        })
        .catch((err) => {
          this.serverErrorHandeler(err);
        })
        .finally(() => {
          this.loading = false;
        });
    },
    printContract() {
      const payload = this.normalizeContractData(
        this.contractData || {
          contract_header: this.contractTitel,
          body: this.contractText,
          contract_date: this.contract_date,
          contract_number: this.contract_number,
          footer: {
            FirstSignature: this.FirstSignature,
            SecondSignature: this.SecondSignature,
          },
        }
      );
      if (payload.contract_date != null && String(payload.contract_date).length) {
        payload.contract_date = this.toPersianDigits(payload.contract_date);
      }
      if (payload.date != null && String(payload.date).length) {
        payload.date = this.toPersianDigits(payload.date);
      }
      if (payload.contract_number != null && String(payload.contract_number).length) {
        payload.contract_number = this.toPersianDigits(payload.contract_number);
      }
      if (payload.number != null && String(payload.number).length) {
        payload.number = this.toPersianDigits(payload.number);
      }
      this.$router.push({
        name: "reportViewer",
        params: {
          dataProp: payload,
          reportProp: "Contract_print",
        },
      });
    },
  },
};
</script>

<style scoped>
.print-contract-page {
  overflow-y: auto;
}

.contract_template {
  min-height: 90vh;
}

.contract_template__loading {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 90vh;
}
</style>
